
import React from "react";
import classes from "./staffMember.module.css";
import { getImageUrl } from "../../../utils/imageUrl";

function StaffMember({ name, position, image, image_url, bio, description, camp }) {
  return (
    <div className={classes.staffMember}>
      <div className={[classes.imageContainer, camp === 'summer' && classes.ImageContainerInSummer, 
        camp === 'winter' && classes.ImageContainerInWinter].join(" ")}>
        <img src={image ? getImageUrl(image) : getImageUrl(image_url)} alt={name} className={classes.staffImage} />
      </div>
      <div className={[classes.details, camp === 'summer' && classes.DetailsInSummer, camp === 'winter' && classes.DetailsInWinter].join(" ")}>
        <h3 className={classes.name}>{name}</h3>
        <p className={[classes.role, camp === 'summer' && classes.RoleInSummer, camp === 'winter' && classes.RoleInWinter].join(" ")}>{position}</p>
        <p className={classes.description}>{bio ? bio : description}</p>
      </div>
    </div>
  );
}

export default StaffMember;
